var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginLock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4748 8.9125H13.2233V5.96086C13.2233 3.97837 12.1656 2.14646 10.4488 1.15518C8.73179 0.163932 6.61657 0.163932 4.89969 1.15518C3.18289 2.14642 2.12511 3.97833 2.12511 5.96086V8.9125H0.873613C0.642027 8.9125 0.419651 9.00457 0.255962 9.16846C0.0920747 9.33235 0 9.55454 0 9.78628V20.5538C0 20.7856 0.0920747 21.0078 0.255962 21.1717C0.419685 21.3354 0.642044 21.4275 0.873613 21.4275H14.4747C14.7063 21.4275 14.9287 21.3354 15.0924 21.1717C15.2563 21.0078 15.3484 20.7856 15.3484 20.5538V9.78628C15.3484 9.55453 15.2563 9.33232 15.0924 9.16846C14.9287 9.00457 14.7063 8.9125 14.4747 8.9125H14.4748ZM3.30584 5.96086C3.30584 4.4002 4.13846 2.95816 5.4901 2.17775C6.84173 1.39734 8.50696 1.39734 9.85852 2.17775C11.2102 2.95816 12.0428 4.4002 12.0428 5.96086V8.9125H3.30593L3.30584 5.96086ZM14.1679 20.2468H1.18067V10.0932H14.1679V20.2468Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginLock);
export default __webpack_public_path__ + "static/media/loginLock.593797e85a55bf4756474f754ce57842.svg";
export { ForwardRef as ReactComponent };